import feedIcon from '../../../assets/mainIcon/icons/Vector.png'

function FeedIcon(){
    return <img src={feedIcon} alt="" />
 }

 export default FeedIcon